import {
  Checkbox,
  FormField,
  Section,
  SectionHeader,
  SectionContent,
  useFormContext,
} from '@predoc/cow';
import { RequestActionFormFieldProps } from './validation';

export const MedicationData = () => {
  const { control } = useFormContext();

  return (
    <Section className="bg-white">
      <SectionHeader>
        <h1 className="text-xl font-bold">Medications Data</h1>
      </SectionHeader>
      <SectionContent>
        <FormField
          control={control}
          name="MEDICATIONS.retrieveMedications"
          render={({ field }: RequestActionFormFieldProps<'MEDICATIONS'>) => (
            <Checkbox
              {...field}
              disabled
              label="Retrieve Medications Data"
              checked={true}
            />
          )}
        />
      </SectionContent>
    </Section>
  );
};
